<template>
  <div id="app" :class="{'card': showNavigation }">
    <site-navigation v-if="showNavigation"></site-navigation>
    <offline-mode></offline-mode>
    <feedback v-if="showNavigation"></feedback>
    <loading></loading>
    <router-view v-if="!isAppLoading"></router-view>

    <help></help>
    <privacy></privacy>
    <disclaimer></disclaimer>
  </div>
</template>

<script>
  import SiteNavigation from './components/layout/SiteNavigation';
  // import Auth from './services/Auth';
  import OfflineMode from './components/OfflineMode';
  import Loading from './components/Loading';
  // import store from './store/store';
  import {mapActions, mapGetters} from 'vuex';
  import Feedback from "./components/Feedback.vue";
  import Help from "./components/pages/Help";
  import Privacy from "./components/pages/Privacy";
  import Disclaimer from "./components/pages/Disclaimer";

  export default {
    name: 'app',
    components: {
      Disclaimer,
      Privacy,
      Help,
      Feedback,
      SiteNavigation,
      OfflineMode,
      Loading
    },
    watch: {
      expired(val) {
        if (val) {
          this.setOfflineMode(true);
        }
      },
    },
    computed: {
      ...mapGetters({
        isAppLoading: 'loading/isAppLoading',
        loggedin: 'auth/loggedin',
        expiry: 'auth/expiry',
      }),
      expired() {
        return (this.expiry < Math.floor(Date.now() / 1000));
      },
      showNavigation() {
        return (this.loggedin && this.$route.name !== "login") && !this.isAppLoading;
      }
    },
    methods: {
      ...mapActions({
        setOfflineMode: 'auth/setOfflineMode',
      }),
    },
  };
</script>

<style>
  .tabs {
    background-color: #FFF;
    margin-bottom: 0;
    height: 40px;
    display: inline-flex;
    width: 100%;
    overflow: hidden;
  }

  .tab {
    background: transparent;
    border: 0;
    min-width: 50%;
    max-width: 180px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    font-weight: bold;
    color: #3F3F3F;
    border-bottom: 4px solid transparent;
    transition: 150ms all ease-in-out;
  }

  .tab.active {
    border-color: #4a148c;
  }


</style>



// WEBPACK FOOTER //
// src/App.vue